import "./QuoteRequest.module.css";
import Header from "@/reusable_sections/Header";
import QuoteHero from "./sections/QuoteHero";
import RequestYourFreeQuote from "./sections/RequestYourFreeQuote";
import OurProcess from "./sections/OurProcess";
import Quotefaq from "./sections/Quotefaq";
import LocalServices from "./sections/LocalServices";
import IncludedBenefitsQuote from "./sections/IncludedBenefitsQuote";
import Footer from "@/reusable_sections/Footer";
export default function QuoteRequestPage() {
  return <div>
      <Header />
      <QuoteHero />
      <RequestYourFreeQuote />
      <OurProcess />
      <LocalServices />
      <IncludedBenefitsQuote />
      <Quotefaq />
      <Footer />
    </div>;
}